import React  from "react";
import CategoryCard from "../../components/products/categorycard";
import categories from "../../assets/data/category";
import { Link } from "react-router-dom";

function CategoryList() {


  return (
      <Link to="/related">
    <div className="pt-5 md:items-center md:justify-center lg:justify-between  flex flex-wrap  gap-4">
      {categories.map((item) => (
        <CategoryCard
          key={item._id}
          category={item.Category}
          image={item.image}
        />
      ))}
    </div>
      </Link>
  );
}

export default CategoryList;

